import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import { createBranchDeliveryZone, getBranchesDeliveryZones, getDeliveryZoneInBranches } from "../../services/branchesDeliveryZonesService";
import { useParams } from "react-router-dom";

export default function CreateDeliveryZoneModal ({ data, onClose }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { handleSubmit, setValue } = useForm();
  const toast = useToast({position: "top",duration: 3000,status: "success",});

  const branchesDeliveryZones = useSelector((state) => state.branchesDeliveryZones);
  //console.log("ggg" , branchesDeliveryZones);

  useEffect(() => {
    dispatch(getBranchesDeliveryZones());
  }, [dispatch]);

  const id = useParams()
  //console.log(id.branchId)
  //const { branchId } = useParams();

  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });


  return <>
      <GModal
      onClose={onClose}
      modalHeader={t("pages.branches.add_delivery_zone")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              //values.DeliveryZoneId = values.DeliveryZoneId.DeliveryZoneId;
              if (values.DeliveryZoneId=== undefined||values.DeliveryZoneId.length<=0){
                toast2({
                  description: t("pages.DailyRestrictions.searchvalidation"),
                });
              }else{
                values.BranchId=id.branchId
                values.DeliveryZoneId = values.DeliveryZoneId?.map((el) => ({
                  DeliveryZoneId: el.DeliveryZoneId,
                }));
                console.log(values)
                dispatch(createBranchDeliveryZone(values))
                  .unwrap()
                  .then((_) => {
                    toast({
                      description: t("pages.branches.delivery_zone_created"),
                    });
                    dispatch(getDeliveryZoneInBranches(id.branchId));
                    onClose();
                  });
              }
          
            })}
          >
            <Stack spacing={6}>
              <MultiSelect
                title={t("pages.branches.delivery_zone")}
                data={
                  branchesDeliveryZones.DeliveryZones &&
                  branchesDeliveryZones.DeliveryZones.map((el) => ({
                    ...el,
                    label: el.DeliveryZoneName,
                    value: el.DeliveryZoneId,
                  }))
                }
                onChange={(e) => setValue("DeliveryZoneId", e)}
                isMulti={true}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={branchesDeliveryZones.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={branchesDeliveryZones.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  
  </>
 };
